module.exports = __webpack_public_path__ + "static/img/placholder_1024.471b4871.svg";